import React from 'react'
import {
	AddMoreButton,
	FileIconBox,
	FileInfo,
	FileListHeader,
	FileListPanel,
	FileMeta,
	FileMetaDot,
	FileMetaError,
	FileMetaReady,
	FileName,
	FileRemoveButton,
	FileRowRoot,
} from '../ItineraryImportPage.styles'
import { FileEntry, formatBytes, isImageMime, isPdfMime, MAX_IMPORT_FILES } from '../utils'
import { FileGlyph, ImageGlyph, PlusGlyph, XGlyph } from './icons'

interface FileRowProps {
	entry: FileEntry
	onRemove: () => void
}

const FileRow: React.FC<FileRowProps> = ({ entry, onRemove }) => {
	const kind: 'pdf' | 'image' = isImageMime(entry.file.type) ? 'image' : 'pdf'
	return (
		<FileRowRoot $error={!!entry.error} $kind={kind}>
			<FileIconBox $error={!!entry.error} $kind={kind}>
				{kind === 'image' ? <ImageGlyph size={18} /> : <FileGlyph size={18} />}
			</FileIconBox>
			<FileInfo>
				<FileName $error={!!entry.error}>{entry.file.name}</FileName>
				<FileMeta>
					<span>{formatBytes(entry.file.size)}</span>
					{entry.pageCount !== undefined && isPdfMime(entry.file.type) && (
						<>
							<FileMetaDot>·</FileMetaDot>
							<span>{entry.pageCount} pages</span>
						</>
					)}
					{entry.error ? (
						<>
							<FileMetaDot>·</FileMetaDot>
							<FileMetaError>{entry.error}</FileMetaError>
						</>
					) : (
						<>
							<FileMetaDot>·</FileMetaDot>
							<FileMetaReady>Ready</FileMetaReady>
						</>
					)}
				</FileMeta>
			</FileInfo>
			<FileRemoveButton type="button" onClick={onRemove} aria-label="Remove">
				<XGlyph size={14} />
			</FileRemoveButton>
		</FileRowRoot>
	)
}

interface FileListProps {
	files: FileEntry[]
	onRemove: (id: string) => void
	onAddMore: () => void
}

const FileList: React.FC<FileListProps> = ({ files, onRemove, onAddMore }) => {
	const slotsRemaining = Math.max(0, MAX_IMPORT_FILES - files.length)
	return (
		<FileListPanel>
			<FileListHeader>
				<span>
					{files.length} {files.length === 1 ? 'file' : 'files'} attached
				</span>
				<span>
					{slotsRemaining} of {MAX_IMPORT_FILES} slots remaining
				</span>
			</FileListHeader>
			{files.map(entry => (
				<FileRow key={entry.id} entry={entry} onRemove={() => onRemove(entry.id)} />
			))}
			{files.length < MAX_IMPORT_FILES && (
				<AddMoreButton type="button" onClick={onAddMore}>
					<PlusGlyph size={14} /> Add more
				</AddMoreButton>
			)}
		</FileListPanel>
	)
}

export default FileList
